<template>
  <Calculator/>
</template>

<script>
import Calculator from "../components/Calculator";

export default {
  name: "ThemeDefaultOnlyChat",
  components: {
    Calculator
  }
}
</script>

<style lang="scss">
// Color system

// defaultny text
$text: #0a1632 !default;
// farba textu v mesagoch
$textWhite: #ffffff !default;
// zelene texty a zvyraznenia v dotazniku
$textGreen: #00a95f !default;
// zelene texty chatu
$textGreenDark: #258B66 !default;
// pozadie obdĺžnika prvej analyzy
$BGcolor: #edf5f7 !default;
// biele pozadie v prvej analyze, chat, obaly odpovedi
$BGcolorWhite: #ffffff !default;
// pozadie chatu kde sa zobrazujú správy
$BGcolorSmoked: #f8f9fa !default;
// farba buttonu dalej
$BGcolorGreen: #00a95f !default;
// farba ctacka v chate
$BGcolorGreenDark: #11845b !default;
// farba textu keď nie su spravy (bannery v chate)
$noMessageColor: #707c97 !default;

@import "../css/indexV0";

.chat-extern-domain {
  display: none!important;
}

</style>